import { useState } from 'react';
import classNames from "classnames";
import styles from '../styles/faq.module.scss';
import helpData from '../data/help.json';
import { QA } from '../model/interfaces';

function FAQ() {
  const [activeItem, setActiveItem] = useState<number | null>(null)

  return (
      <div className={styles.accordion}>
        {helpData.faqs.map((faq, i) => (
          <FaqDetails faq={faq} isOpen={i === activeItem} index={i} toggleFAQ={setActiveItem} />
        ))}
      </div>
  );
}

function FaqDetails (props: {faq: QA, index: number, toggleFAQ: (index: number) => void, isOpen: boolean}) {
  const { faq, index, toggleFAQ, isOpen } = props

  return (
    <div
      className={classNames(styles.faq, styles[isOpen ? 'open' : '']) }
      key={index}
      onClick={() => toggleFAQ(!isOpen ? index : -1)}
    >
      <div className={styles['faq-question']}>
        {faq.question}
      </div>
      <div className={styles['faq-answer']}>
        {faq.answer}
      </div>
    </div>
  )
}

export default FAQ
